/* ============================================
   Dhenika — NAVIGATION LINKS
   ============================================ */

const navLinks = [
  { id: 1, label: 'Features',    href: '#features'     },
  { id: 2, label: 'How it works',href: '#how-it-works' },
  { id: 3, label: 'Screenshots', href: '#screenshots'  },
  { id: 4, label: 'Download',    href: '#download'     },
];

export default navLinks;